import { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Loader from '../Loader/Loader';

// public components
import CreateOrUpdateUser from '../../../Pages/User/CreateOrUpdateUser/FormUser';
// import Error from '../../../Pages/Error/Error';
import ForgotPassword from '../../../Pages/ForgotPassword/ForgotPassword';
import SaveNewPassword from '../../../Pages/ForgotPassword/SaveNewPassword';
import FormCandidate from '../../../Pages/NewCandidate/FormCandidate';
import Tutorials from '../../../Pages/Tutorials/sections/VideosSection';
import { REACT_APP_ROUTE_HOME } from '../../../components/common/Routes/URLs';

// Lazy load components

// Maintenance page
import MaintenancePage from '../../../Pages/Manteinance/Manteinance';

const Home = lazy(() => import('../../../Pages/Home/Home'));
const Login = lazy(() => import('../../../Pages/Login/Login'));
const PrivateRoutes = lazy(() => import('../PrivateRoutes/PrivateRoutes'));

function AppRoutes() {
  const showMaintenance = process.env.REACT_APP_SHOW_MAINTENANCE === 'true';

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public routes */}
        <Route path="/tutorials/:lang" element={<Tutorials />} />
        <Route path={`${REACT_APP_ROUTE_HOME(':lang')}`} element={<Home />} />
        <Route path="/candidate/registration/:id/:lang" element={<FormCandidate />} />
        <Route path="/signin/:lang" element={showMaintenance ? <MaintenancePage /> : <Login />} />
        <Route path="/register/:lang" element={<CreateOrUpdateUser />} />
        <Route path="/resetPassword/:lang" element={<ForgotPassword />} />
        <Route path="/saveNewPassword/:id/:lang" element={<SaveNewPassword />} />
        {/* <Route path="/pending/user/:lang" element={<Error />} /> */}
        {/* <Route path="/pending/agency/:lang" element={<Error />} /> */}
        {/*  <Route path="/denied/user/:lang" element={<Error />} /> */}
        {/* <Route path="/denied/agency/:lang" element={<Error />} /> */}
        {/* <Route path="/error/:lang" element={<Error />} /> */}

        {/* Protected routes */}
        <Route path="/*" element={<PrivateRoutes />} />

        {/* Catch all route - redirect to home */}
        <Route path="*" element={<Navigate to={REACT_APP_ROUTE_HOME('en')} replace />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
